import dynamic from 'next/dynamic'

export * from './EditMe'
export * from './OttEditMe'
export * from './RedAlert/RedAlert'
export * from './OttAdminBar/OttAdminBarLoader'
export * from './ErrorBoundary/ErrorBoundary'
export * from './IdxMetaTags'
import Ad from './Ads/Ad'
import AutoRefresh from './AutoRefresh'
import { DebugConsoleLog } from './DebugConsoleLog'
import { PageLoader } from './PageLoader/PageLoader'
import GoogleAd from './GoogleAd/GoogleAd'
export const KalturaThumbnailEmbed = dynamic(
  () =>
    import('./KalturaThumbnailEmbed/Kalturathumbnailembed').then(
      m => m.default
    ),
  {
    ssr: true,
  }
)

export { Ad, AutoRefresh, DebugConsoleLog, PageLoader, GoogleAd }
